// extracted by mini-css-extract-plugin
export default {"label":"DatePicker_label__Yw9WA","inlineLabel":"DatePicker_inlineLabel__Lpqhj","select":"DatePicker_select__h9xxt"};